import { z } from 'zod';

export const ImportInboundBodySchema = z.looseObject({
  xml: z.string().min(1),
  supplierRoleId: z.uuid(),
});

export const ImportInboundResponseSchema = z.looseObject({
  fiscalDocumentId: z.uuid(),
});

const PositiveCentsSchema = z.string().regex(/^[1-9]\d*$/, 'must be a positive integer string');

export const RegisterInboundScheduleItemSchema = z.looseObject({
  dueDate: z.iso.date(),
  amountCents: PositiveCentsSchema,
});

export const RegisterInboundBodySchema = z.looseObject({
  xml: z.string().min(1),
  supplierRoleId: z.uuid(),
  chartOfAccountId: z.uuid(),
  schedule: z.array(RegisterInboundScheduleItemSchema).min(1).optional(),
  notes: z.string().trim().max(2_000).nullable().optional(),
});

export const RegisterInboundResponseSchema = z.looseObject({
  fiscalDocumentId: z.uuid(),
  conferenceId: z.uuid(),
  payableDocumentGroupId: z.uuid(),
  unmatchedLineCount: z.number().int().nonnegative(),
});

export const InboundDocumentIdParamsSchema = z.looseObject({
  placeId: z.uuid(),
  id: z.uuid(),
});

export const FinalizeInboundResponseSchema = z.looseObject({
  fiscalDocumentId: z.uuid(),
  conferenceId: z.uuid(),
  inboundOperationalStatus: z.literal('FINALIZED'),
});

export const CancelInboundBodySchema = z.looseObject({
  justification: z.string().trim().min(15).max(255),
});

export const CancelInboundResponseSchema = z.looseObject({
  fiscalDocumentId: z.uuid(),
  status: z.literal('CANCELLED'),
  cancelledPayableCount: z.number().int().nonnegative(),
  conferenceId: z.uuid().nullable(),
});

export type ImportInboundBody = z.infer<typeof ImportInboundBodySchema>;
export type ImportInboundResponse = z.infer<typeof ImportInboundResponseSchema>;
export type RegisterInboundBody = z.infer<typeof RegisterInboundBodySchema>;
export type RegisterInboundResponse = z.infer<typeof RegisterInboundResponseSchema>;
export type InboundDocumentIdParams = z.infer<typeof InboundDocumentIdParamsSchema>;
export type FinalizeInboundResponse = z.infer<typeof FinalizeInboundResponseSchema>;
export type CancelInboundBody = z.infer<typeof CancelInboundBodySchema>;
export type CancelInboundResponse = z.infer<typeof CancelInboundResponseSchema>;
